// ADR 23.9.26w §10 — the queue's five events. Consent-gated through
// `capture()`, like every other event, and content-free: kinds, statuses and
// counts only — never a card, list or op id, never a quality value.
//
// New names on purpose (the tts_played lesson): no existing panel counts them,
// and they are web-only because they measure the browser's queue.

import { capture } from '../../telemetry/capture'
import type { OpKind } from './types'

/** Why an op was stored: known offline, or the attempt got no response. */
export type QueueCause = 'offline' | 'no_response'

export function opQueued(kind: OpKind, cause: QueueCause): void {
  capture('offline_op_queued', { kind, cause })
}

/** The discard rule dropped an op, or its record failed the kind guard (`unreadable`, status 0). */
export function opDiscarded(kind: OpKind | 'unreadable', status: number): void {
  capture('offline_op_discarded', { kind, status })
}

/** The 30-day sweep deleted an op nobody drained. */
export function opExpired(kind: OpKind | 'unreadable'): void {
  capture('offline_op_expired', { kind })
}

export function queueRefused(reason: 'cap' | 'storage'): void {
  capture('offline_queue_refused', { reason })
}

export interface DrainCounts {
  sent: number
  discarded: number
  kept: number
  /** The first kept status, `0` for no response, or `null` when nothing was kept. */
  stopped_status: number | null
}

/** A pass ended having attempted at least one op. */
export function queueDrained(counts: DrainCounts): void {
  capture('offline_queue_drained', { ...counts })
}
